import React from "react";
import { ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";
import ChartTypeTitle from "./ChartTypeTitle";
import { toggleTypeSets } from "./const";
import { GraphType } from "@services/monitoring/types";

type ChartTypeToggleProps = {
  onToggle: (type: GraphType) => void;
  chartType: GraphType;
};

const ChartTypeToggle = ({ onToggle, chartType }: ChartTypeToggleProps) => {
  const toggleStates = toggleTypeSets.find((set) => set.includes(chartType));

  const handleChange: ToggleButtonGroupProps["onChange"] = (_, type) => {
    if (!type) return;

    onToggle(type);
  };

  if (!toggleStates) return null;

  return (
    <ToggleButtonGroup
      exclusive
      onChange={handleChange}
      value={chartType}
      size="small"
      sx={{ verticalAlign: "middle" }}
    >
      {toggleStates.map((type, index) => (
        <ChartTypeTitle key={index} chartType={type} value={type} />
      ))}
    </ToggleButtonGroup>
  );
};

export default ChartTypeToggle;
